import { PortfolioAnalyzerFilters } from "../../types";
import ApiClient from "../api";

export const getGlobalFilters = async (periodType: string) => {
  const response = await ApiClient.get<PortfolioAnalyzerFilters>(`/portfolio_analyzer/global-filters?period=${periodType}`);
  return response.data;
};
